export default __webpack_public_path__ + "static/media/charge_pump_positive_4_diodes.914b1eb2.svg";